import {observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";

export default class QuantidadeMOTStore {
    @observable erro;
    @observable carregando;
    @observable dados;

    constructor() {
        this.indicadorService = new IndicadorService();
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findVisaoGeralSolicitacoes(filtro).then(response => {
            this.dados = response.data.map(situacao => ({
                nome: situacao.situacao,
                "Quantidade": situacao.quantidade
            }))
        
            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }
}
